import { makeStyles } from '@material-ui/styles';
import { DefaultTheme } from '@material-ui/styles';

const useStyles = makeStyles<DefaultTheme>({
    view_horizon_munsell: {
        width: '100%',
        backgroundColor: 'transparent',
    },
    view_horizon_munsell_title: {
        backgroundColor: 'transparent',
        marginTop: '20px !important',
        marginBottom: '10px !important',
    },
    text_horizon_munsell: {
        fontFamily: 'serca-condensed-text',
        letterSpacing: 1,
        fontSize: 16,
        color: "#000000",
        fontWeight: "bold",
        textAlign: "center"
    },
    text_horizon_munsell_subtitle: {
        fontFamily: 'serca-condensed-text',
        letterSpacing: 1,
        fontSize: 14,
        color: "#000000",
        paddingLeft: 5,
        textAlign: "left"
    },
    view_horizon_munsell_content: {
        width: '100%',
        flexDirection: 'column',
        backgroundColor: 'transparent',
        marginBottom: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    view_horizon_munsell_checkobx_content: {
        flexDirection: 'row',
        backgroundColor: 'transparent',
    },
    text_check_item: {
        width: '100%',
        color: "#000000 !important",
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'transparent',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'none',
    },
    button_checkobox_munsell_mottled_variegated: {
        width: '100%',
        flexDirection: 'row',
        backgroundColor: 'transparent',
        marginBottom: 5,
    },
    view_horizon_munsell_inputs_content: {
        width: '100%',
        margin: '5px 0px !important',
        flexDirection: 'row',
        backgroundColor: 'transparent',
    },
    grid_input_data_munsell: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    input_data_munsell: {
        width: '200px',
        backgroundColor: 'transparent',
        borderColor: '#CDCDCD',
        borderWidth: 1,
        padding: '8px 15 !important',
        margin: '0px 5px !important',
        borderRadius: 10,
        textAlign: 'center',
        verticalAlign: 'center',
        justifyContent: 'center',
        '& .MuiOutlinedInput-input': {
            textAlign: 'center',
            color: '#06617c !important',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #06617c !important',
        }
    },
    view_horizon_extra_munsell_view: {
        width: '100%',
        flexDirection: 'column',
        backgroundColor: 'transparent',
        margin: '5px 0px !important',
        justifyContent: 'space-around',
    },
});

export default useStyles;